// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__ZDNFF","form":"styles_form__1lpM6"};